import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import './aboutcomp.css'
import Image from 'react-bootstrap/Image' 
import Profile from '../../assets/mypic.jpeg'
import Button from 'react-bootstrap/Button'


const About = () => {
    return (
        <div id='about'>
            <div className='about'>
                <h1 className="pt-3 text-center font-details pb-3">About Me</h1>
                <Container>
                    <Row className="pt-3 pb-5 align-items-center">
                        <Col xs={12} md={6}>
                            <Row className="justify-content-center mb-2 mr-2 ">
                                <Image className="profile justify-content-end" alt="profile" src={Profile} thumbnail />
                            </Row>
                        </Col>
                        <Col xs={12} md={6}>
                            <Row className=" align-items-start p-2 my-details rounded">
                                 Hi Respected Viewer! Its Me <strong>&nbsp;Zaid Sultan</strong>
                                <br />A passionate Learner and Developer. I am a Full Stack Software Engineer with skills like React.js, Redux, Express.js, Node.js, and MongoDB as my tech stack applied on practical projects.
                                <br />
                                In 2019, I successfully completed my Engineering with specialization in 'Computer Science'.
                                <br />
                                Currently Working as a Web developer and E-Commerece Manager at SMCSE
                                <br />
                                Along with that, I also help people solve their problems in coding and in ideas. 
                                <br />I love learning about new technologies, what problems are they solving and How can I use them to build better and scalable products.
                                <br/>I love to learn new things everyday, I'm fully motivated to progress in the field of AI and Cloud as well as mastering software Engineering
                                <br /> <br />
                                    <Col className="d-flex justify-content-center flex-wrap">
                                        <div>
                                            <a href="#contact">
                                            <Button className="m-2" variant="outline-primary">
                                                Let's talk
                                            </Button>
                                            </a>
                                        </div>
                                        <div>
                                            <a href="https://drive.google.com/file/d/1Wq2HnUM4fbS3d1x-dKgkiVHUQRO7Vtsc/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                                            <Button className="m-2" variant="outline-success">
                                                My Resume
                                            </Button>
                                            </a>
                                        </div>
                                        <div>
                                            <a href="https://github.com/ZaidSultan10" target="_blank" rel="noopener noreferrer">
                                            <Button className="m-2" variant="outline-dark">
                                                GitHub
                                            </Button>
                                            </a>
                                        </div>
                                        <div>
                                            <a href="https://www.linkedin.com/in/zaid-sultan/" target="_blank" rel="noopener noreferrer">
                                            <Button className="m-2" variant="outline-info">
                                                LinkedIn
                                            </Button>
                                            </a>
                                        </div>
                                    </Col>
                            </Row>
                            
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default About
